// Module
var code = "";
// Exports
var _module_exports =code;;
var path = 'app/components/tokbox/tokbox.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;